export const WORK_ROUTES = {
  WORK_DRAFTS: "/drafts",
  WORK_PROJECTS: "/projects",
  WORK_TASKS: "/tasks",
  WORK_CUSTOM_VIEW: "/custom-view",
  WORK_ANALYTICS: "/operate/analytics",
} as const;

export type WorkRouteKey = keyof typeof WORK_ROUTES;
